import Head from 'next/head';
import TermsDesktop from 'components/terms/terms-desktop';
import MiscLocale from 'locale/en/misc.json';
import TermsLocale from 'locale/en/terms.json';
import { getContentSection } from 'lib/contentful/get-content-section';
import { getContentField } from 'lib/contentful/get-content-field';
import { getContentfulDataDirect } from 'lib/contentful/get-contentful-data-direct';

const PageData = {
  page_type: 'default',
  page_class: 'page-terms',
  page_name: TermsLocale.page_name,
  page_title: TermsLocale.page_title,
  page_description: TermsLocale.page_desc,
};
const PageHead = () => (
  <Head>
    <title>{`${MiscLocale.brand} • ${PageData.page_title}`}</title>
    <meta name='description' content={PageData.page_description} />
  </Head>
);

type PageTermsProps = {
  pagePayload: object;
};

const PageTerms = (props: PageTermsProps) => {
  const { pagePayload } = props;

  const section = getContentSection({
    data: pagePayload,
    include: 'Terms + Conditions - Main Section',
  })?.shift();

  const content = getContentField({
    data: section,
    title: 'Terms + Conditions - Main Paragraph',
  });

  return (
    <>
      <PageHead />
      <TermsDesktop content={content} />
    </>
  );
};

export async function getStaticProps() {
  const pageQuery = {
    content_type: 'page',
    'fields.slug': 'terms-conditions',
    include: 10,
  };

  const pagePayload = (await getContentfulDataDirect(pageQuery)).items[0]
    .fields;

  const props = {
    pagePayload,
  };

  return {
    props,
    revalidate: 60 * 60, // One hour in seconds
  };
}

export default PageTerms;
